import { Box, Typography } from '@material-ui/core';

import { ControlledSelect } from '../../../../components/controlled-inputs';
import { selectOptions } from '../config/constants';
import { getNameForField } from '../helpers/getNameForField';
import { EnumSchema, RuleSchema } from '../types';

export const FullWorkDayBonus = ({ uuid, ...rest }: RuleSchema) => {
  const hoursTypeNeeded = rest.hours_type_needed as unknown as EnumSchema;
  return (
    <Box marginTop={1} marginBottom={1} display="flex" gridGap={8} alignItems="center" flexWrap="wrap">
      <Typography variant="caption" color="textSecondary">
        When a team member completes
      </Typography>
      <Box width="94px">
        <ControlledSelect name={getNameForField(uuid, 'hours_amount_needed')} items={selectOptions.hours} />
      </Box>

      <Box width="130px">
        <ControlledSelect
          name={getNameForField(uuid, 'hours_type_needed')}
          items={hoursTypeNeeded.options}
        />
      </Box>
      <Typography variant="caption" color="textSecondary">
        hours in a work day, add a bonus of
      </Typography>
      <Box width="94px">
        <ControlledSelect name={getNameForField(uuid, 'bonus_hours')} items={selectOptions.hours} />
      </Box>
      <Typography variant="caption" color="textSecondary">
        hours and
      </Typography>
      <Box width="94px">
        <ControlledSelect name={getNameForField(uuid, 'bonus_minutes')} items={selectOptions.minutes} />
      </Box>
      <Typography variant="caption" color="textSecondary">
        minutes to the daily time log, paid at a rate of
      </Typography>
      <Box width="94px">
        <ControlledSelect name={getNameForField(uuid, 'bonus_rate')} items={selectOptions.rates} />
      </Box>
      <Typography variant="caption" color="textSecondary">
        × their hourly rate.
      </Typography>
    </Box>
  );
};
